<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-card-text   v-html="question">
    </v-card-text>
    <template #actions>
      <v-btn @click="ok">Ок</v-btn>
      <v-btn v-show="!noCancel" @click="cancel">Отмена</v-btn>
    </template>  
  </v-btn-form>  
</template>

<script type="text/javascript">
  import vBtnForm from '../common/BtnForm'
  let o = {
    name: 'confirm-form',
    components: {vBtnForm},
    data: () => ({
      edit: false,
      valid: false,
      item: {}
    }),
    props: {
      title: {
        type: String,
        default: 'Подтвердите'
      },
      question: {
        type: String,
        default: 'Подтвердите операцию'
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      noCancel: {
        type: Boolean,
        default: false
      }
    },
    computed: {
    },
    methods: {
      ok () {
        this.$emit('ok')
        this.$emit('close')
      },
      cancel () {
        this.$emit('cancel')
        this.$emit('close')
      }
    }
  }
  export default o
</script>




// WEBPACK FOOTER //
// ConfirmForm.vue?016c968b